var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 10,
    viewBox: "0 0 15 10",
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.03125 9.35156h5.75391c1.45314 0 2.28514-.82031 2.28514-2.23242v-.62695l1.9453 1.65234c.2813.23438.5625.39258.8438.39258.5156 0 .873-.36914.873-.93164v-5.81836c0-.5625-.3574-.931641-.873-.931641-.2871 0-.5625.158201-.8438.392581l-1.9453 1.65234v-.66211c0-1.417968-.832-2.23828-2.28514-2.23828h-5.75391c-1.41211 0-2.285156.820312-2.285156 2.23828v4.9336c0 1.4121.832026 2.17968 2.285156 2.17968zm.19336-1.07226c-.84375 0-1.33008-.46289-1.33008-1.33594v-4.53516c0-.89062.48633-1.33008 1.33008-1.33008h5.36719c.84375 0 1.33008.45704 1.33008 1.33008v4.53516c0 .87305-.49219 1.33594-1.33594 1.33594zm10.20699-1.11914-2.3613-1.92188v-1.08398l2.3613-1.92188c.0469-.03515.0821-.05859.1231-.05859.0644 0 .0937.04687.0937.11719v4.8164c0 .07031-.0293.11719-.0937.11719-.041 0-.0762-.0293-.1231-.06445z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.edea4ae3.svg";
export { ForwardRef as ReactComponent };